import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import InputGroup from "react-bootstrap/InputGroup";
import Toast from "react-bootstrap/Toast";
import Alert from "react-bootstrap/Alert";
import ToastContainer from "react-bootstrap/ToastContainer";
import { FaCheck, FaChevronRight } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { IconContext } from "react-icons";
// Use of Formik and Yup
import * as formik from "formik";
import contactInitValues from "../../../__params/validationschema/contact/contactInitValues";
import contactSchema from "../../../__params/validationschema/contact/contactSchema";
import "../../../assets/css/contact-form.css"; // Fichier CSS pour les placeholders

const ContactUs = () => {
  const formContact = useRef();
  const { Formik } = formik;

  const [messageStatus, setMessageStatus] = useState(false);

  useEffect(() => {
    if (messageStatus) {
      setTimeout(() => {
        setMessageStatus(false);
      }, 3000);
    }
  }, [messageStatus]);

  const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_CONTACT_ID;
  const PUBLIC_ID = process.env.REACT_APP_EMAILJS_PUBLIC_ID;

  const sendEmail = async (values, { setSubmitting, resetForm, setStatus }) => {
    await emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, formContact.current, PUBLIC_ID)
      .then(
        (result) => {
          setMessageStatus(true);
          resetForm();
          setSubmitting(true);
        },
        (error) => {
          setMessageStatus(false);
          setSubmitting(false);
          setStatus({
            success: false,
            message: "Erreur lors de l'envoi du message.",
          });
        }
      );
  };

  return (
    <main role="main" className="mc-fond-ecran">
      <Container fluid>
        <Row className="gx-0">
          <Card className="bg-transparent flex-lg-row justify-content-between mx-2 mt-3 border-0">
            <Col lg={5} className="p-3">
              <Card.Body className="m-1">
                <Card.Title as="h5" className="mt-5">
                  Bonjour,
                </Card.Title>
                <Card.Text>
                  Pour toute demande d'informations ou pour adresser vos
                  suggestions au bureau du TCF, n'hésitez pas à compléter le
                  formulaire ci-joint.
                  <br />
                  <br />
                  Nous nous ferons un plaisir de vous répondre dans les plus
                  brefs délais.
                  <br />
                </Card.Text>
                <Card.Text>
                  Bien Cordialement.
                  <br />
                  <strong>Le bureau du TCF</strong>
                </Card.Text>
              </Card.Body>
            </Col>

            <Col lg={7} className="p-3">
              <Card.Body className="fw-semibold border border-2 rounded p-4">
                <Card.Header className="bg-warning-subtle text-center mb-3">
                  Formulaire de contact
                </Card.Header>
                <Formik
                  initialValues={contactInitValues}
                  validationSchema={contactSchema}
                  onSubmit={sendEmail}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    status,
                    resetForm,
                  }) => (
                    <Form ref={formContact} noValidate onSubmit={handleSubmit}>
                      {status && (
                        <Alert
                          variant={status.success ? "success" : "danger"}
                          className="mb-4"
                        >
                          {status.message}
                        </Alert>
                      )}
                      {messageStatus && (
                        <div>
                          <ToastContainer position={"bottom-center"}>
                            <Toast>
                              <Toast.Header
                                closeButton={false}
                                className="bg-success text-light"
                              >
                                <IconContext.Provider value={{ size: "2em" }}>
                                  <FaCheck />
                                </IconContext.Provider>
                              </Toast.Header>
                              <Toast.Body className="bg-success text-light text-center">
                                Votre message a bien été transmis ! <br />
                                Nous vous répondrons dans les plus brefs délais
                                Cordialement.
                              </Toast.Body>
                            </Toast>
                          </ToastContainer>
                        </div>
                      )}
                      <InputGroup className="mb-3" required>
                        {/* <Col xs={1}></Col> */}
                        <InputGroup.Text
                          column
                          xs={1}
                          className="bg-transparent border-0"
                        >
                          🪪
                        </InputGroup.Text>
                        <Form.Label column xs={2}>
                          Nom :
                        </Form.Label>

                        <Form.Control
                          column
                          xs={9}
                          className="rounded placeholderCustom"
                          type="text"
                          placeholder="Entrez votre nom"
                          name="contactName"
                          value={values.contactName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isValid={touched.contactName && !errors.contactName}
                          isInvalid={touched.contactName && errors.contactName}
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          className="mc-rfs-6 d-block fst-italic text-end pe-2"
                        >
                          {errors.contactName}
                        </Form.Control.Feedback>
                      </InputGroup>

                      <InputGroup className="mb-3" required>
                        <InputGroup.Text
                          column
                          xs={1}
                          className="bg-transparent border-0"
                        >
                          @
                        </InputGroup.Text>
                        <Form.Label column xs={2}>
                          Email :
                        </Form.Label>
                        <Form.Control
                          column
                          xs={9}
                          type="email"
                          className="rounded placeholderCustom"
                          placeholder="Entrez votre adresse email"
                          name="contactEmail"
                          value={values.contactEmail}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isValid={touched.contactEmail && !errors.contactEmail}
                          isInvalid={
                            touched.contactEmail && errors.contactEmail
                          }
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          className="mc-rfs-6 d-block fst-italic text-end pe-2"
                        >
                          {errors.contactEmail}
                        </Form.Control.Feedback>
                      </InputGroup>

                      <InputGroup className="mb-3" required>
                        <InputGroup.Text
                          column
                          xs={1}
                          className="bg-transparent border-0"
                        >
                          <BsFillTelephoneFill />
                        </InputGroup.Text>
                        <Form.Label column xs={2}>
                          Tél :
                        </Form.Label>
                        <Form.Control
                          column
                          xs={9}
                          type="tel"
                          className="rounded placeholderCustom"
                          placeholder="Entrez votre numéro de téléphone"
                          name="contactPhone"
                          value={values.contactPhone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isValid={touched.contactPhone && !errors.contactPhone}
                          isInvalid={
                            touched.contactPhone && errors.contactPhone
                          }
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          className="mc-rfs-6 d-block fst-italic text-end pe-2 rounded"
                        >
                          {errors.contactPhone}
                        </Form.Control.Feedback>
                      </InputGroup>

                      <InputGroup className="mb-3" required>
                        <InputGroup.Text
                          column
                          xs={1}
                          className="bg-transparent border-0"
                        >
                          💡
                        </InputGroup.Text>
                        <Form.Label column xs={2}>
                          Objet :
                        </Form.Label>
                        <Form.Control
                          column
                          xs={9}
                          className="rounded placeholderCustom"
                          type="text"
                          placeholder="Entrez l'objet du message"
                          name="contactSubject"
                          value={values.contactSubject}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isValid={
                            touched.contactSubject && !errors.contactSubject
                          }
                          isInvalid={
                            touched.contactSubject && errors.contactSubject
                          }
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          className="mc-rfs-6 d-block fst-italic text-end pe-2 rounded"
                        >
                          {errors.contactSubject}
                        </Form.Control.Feedback>
                      </InputGroup>

                      <Form.Group
                        className="mb-3 px-0"
                        controlId="formBasicEmail"
                        required
                      >
                        <Col xs={12}>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            className="placeholderCustom"
                            placeholder="Entrez votre message ✉️"
                            name="contactMessage"
                            value={values.contactMessage}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isValid={
                              touched.contactMessage && !errors.contactMessage
                            }
                            isInvalid={
                              touched.contactMessage && errors.contactMessage
                            }
                          />
                          <Form.Control.Feedback
                            type="invalid"
                            className="mc-rfs-6 d-block fst-italic lh-1 p-1 ps-2 rounded"
                          >
                            {errors.contactMessage}
                          </Form.Control.Feedback>
                        </Col>
                      </Form.Group>

                      <Button
                        variant="primary"
                        type="submit"
                        value={"send"}
                        disabled={isSubmitting}
                        className="fw-semibold"
                      >
                        {isSubmitting ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-2"
                            />
                            Envoi en cours...
                          </>
                        ) : (
                          <>
                            Envoyer le message&nbsp;
                            <IconContext.Provider value={{ size: "1rem" }}>
                              <FaChevronRight />
                            </IconContext.Provider>
                          </>
                        )}
                      </Button>
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Col>
          </Card>
        </Row>
      </Container>
    </main>
  );
};

export default ContactUs;
